import React, { useCallback, useContext } from 'react'
import { ConfigurationContext } from '@news-mono/web-common'
import {
    StyledBreachWallHelpText,
    StyledBreachWallSupportContainer,
    StyledBreachWallTermsButton,
    StyledBreachWallTermsButtonContainer,
    StyledBreachWallTermsButtonText,
    StyledBreachWallTermsText,
    StyledIconPremium,
    StyledMessageBannerContainer,
    StyledPremiumText,
    StyledTermButtonRightChevron,
} from './BreachWallTerms.styled'
import { useAuthActions } from '../../../authentication'

export const BreachWallTerms = () => {
    const { onLoginClick } = useAuthActions()
    const config = useContext(ConfigurationContext)
    const subscriberLink =
        config.subscribeTheWestUrl || 'https://subscriber.thewest.com.au'

    const onMoreSubscriptionsClick = useCallback(() => {
        window.open(
            `${subscriberLink}/#printPackages`,
            '_blank',
            'noopener,noreferrer',
        )
    }, [subscriberLink])
    const onCorporateSubscriptionsClick = useCallback(() => {
        window.open(
            `${subscriberLink}/corporate-packages`,
            '_blank',
            'noopener,noreferrer',
        )
    }, [subscriberLink])

    return (
        <>
            <StyledBreachWallTermsButtonContainer>
                <StyledBreachWallTermsButton onClick={onMoreSubscriptionsClick}>
                    <StyledBreachWallTermsButtonText>
                        More subscription options
                    </StyledBreachWallTermsButtonText>
                    <StyledTermButtonRightChevron />
                </StyledBreachWallTermsButton>
                <StyledBreachWallTermsButton
                    onClick={onCorporateSubscriptionsClick}
                >
                    <StyledBreachWallTermsButtonText>
                        Corporate subscriptions
                    </StyledBreachWallTermsButtonText>
                    <StyledTermButtonRightChevron />
                </StyledBreachWallTermsButton>
            </StyledBreachWallTermsButtonContainer>
            <StyledBreachWallSupportContainer>
                <StyledBreachWallTermsText>
                    Subscription{' '}
                    <a
                        href={
                            'https://subscriber.thewest.com.au/subscription-terms'
                        }
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                    >
                        Terms &amp; Conditions
                    </a>{' '}
                    apply.
                </StyledBreachWallTermsText>
                <StyledBreachWallHelpText>
                    Need help with a subscription? Call us at 1800 811 855
                </StyledBreachWallHelpText>
            </StyledBreachWallSupportContainer>
            <StyledMessageBannerContainer>
                <StyledIconPremium />
                <StyledPremiumText>
                    Subscribers with digital access can view this
                    article.&nbsp;
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault()
                            onLoginClick('article-inline')
                        }}
                    >
                        Sign in
                    </a>
                </StyledPremiumText>
            </StyledMessageBannerContainer>
        </>
    )
}
